export default __webpack_public_path__ + "static/media/balanceIcon.2148f82b.svg";